import { OnInit, OnDestroy, OnChanges, SimpleChanges, Component, Output, EventEmitter, Input } from '@angular/core';
import { NotifyService } from 'src/app/core/services/notify.service';
import { interval, Subscription, BehaviorSubject } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { isBuffer } from 'util';
import { CommonService } from 'src/app/core/services/common.service';
import { EnumNotificationType } from 'src/app/core/constants/notification';
import { DocumentService } from 'src/app/core/services/document.service';

declare function clearSelectionJ(): any;

export interface Notify {
  id: string;
  contractId: string;
  title: string;
  requestBy: string;
  receivedBy: string;
  notitficationType: any;
  signGroupDetail: any;
  fromName: string;
  fromEnterpriseName: string;
  contractCode: string;
  contractName: string;
  status: any;
  content: string;
  createdTime: any;
  hostname?: any;
  type?: any;
  contractLotId: string;
  objectId: string;
  lotId: string;
  contractLotType?: string;
  isEmploymentContract : string;
  isDigitalEmploymentContract?: boolean;
}

@Component({
  selector: 'app-notify-alert',
  templateUrl: './notify-alert.component.html'
})

export class NotifyAlertComponent implements OnInit, OnChanges, OnDestroy {
  @Input() notifies: Notify[] = [];
  @Input() public totalUnread: number;
  // parent (header) truyền dữ liệu qua input thì con không tự gọi /notification/lasted nữa
  private parentFeedsData = false;
  usType: any;
  // used to unsubscribe from the interval, when OnDestroy is called.
  private alive: boolean;
  private interval: number;
  EnumNotificationType = EnumNotificationType;

  private goFrom = '';
  DEFAULT_ROUTER_ON_BACK_LIST = '/home-enterprise/search-document/';
  DEFAULT_RECEIVER_ROUTER_ON_BACK_LIST = '/home-enterprise/search-document-receive/';
  urlRouteLink = this.DEFAULT_ROUTER_ON_BACK_LIST;

  @Output() notification = new EventEmitter<any>();

  constructor(
    private notifyService: NotifyService,
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private documentService: DocumentService,
  ) {
    this.alive = true;
    this.interval = 5000;
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        // trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
        // if you need to scroll back to top, here is the right place
        window.scrollTo(0, 0);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // input 'notifies' được binding từ cha (fire trước ngOnInit) -> cha tự fetch và truyền data,
    // con không cần gọi /notification/lasted riêng (tránh gọi trùng)
    if (changes['notifies']) {
      this.parentFeedsData = true;
    }
  }

  /**
   * OnInit
   */
  ngOnInit() {
    this.usType = localStorage.getItem('userType');
    // first load notifies
    this.getNotifies();
    // Time interval for 5s
    // interval(this.interval).pipe(takeWhile(() => this.alive)).subscribe(() => {
    //   this.getNotifies();
    // });

  }

  /**
   * Get notifies
   */
  getNotifies() {
    // enterprise flow: header (cha) đã gọi API và truyền data qua input, bỏ fetch trùng
    if (this.parentFeedsData) {
      return;
    }
    this.notifyService.getLastedNotify().subscribe(rs => {
      if (rs == null || rs.data == null) {
        return 0;
      }
      // console.log(rs);
      this.notifies = rs.data.notificationDTO;
      this.totalUnread = rs.data.totalUnread;

    });
  }

  viewDetail(notify: Notify) {
    if (this.usType == 0) {
      return;
    }
    this.notifyService.updateStatus(notify.id).subscribe();
    //set goFrom to queryParams
    if (notify.notitficationType) {
      switch (notify.notitficationType) {
        case 15:
          this.goFrom = 'waitSign';
          break;
        case 24:
          this.goFrom = 'waitSign';
          break;
        case 25:
          this.goFrom = 'waitSign';
          break;
        case 34:
          this.goFrom = 'waitSign';
          break;
        case 16:
          this.goFrom = 'waitApprove';
          break;
        case 32:
          this.goFrom = 'waitApprove';
          break;
        case 33:
          this.goFrom = 'waitApprove';
          break;

        case 23:
          this.goFrom = 'waitInitial';
          break;

        case 18:
          this.goFrom = 'mine';
          break;
        case 19:
          this.goFrom = 'mine';
          break;
        case 20:
          this.goFrom = 'mine';
          break;
        case 21:
          this.goFrom = 'mine';
          break;
        case 22:
          this.goFrom = 'mine';
          break;
        case 36:
          this.goFrom = 'mine';
          break;

        case 17:
          this.goFrom = 'receive';
          break;
        case 26:
          this.goFrom = 'receive';
          break;
        case 27:
          this.goFrom = 'receive';
          break;
        case 29:
          this.goFrom = 'receive';
          break;
        case 30:
          this.goFrom = 'receive';
          break;
        case 31:
          this.goFrom = 'receive';
          break;
        case 35:
          this.goFrom = 'receive';
          break;
        case 37:
          this.goFrom = 'receive';
          break;
        case 38:
          this.goFrom = 'receive';
          break;
        case 40:
          this.goFrom = 'mineReceive';
          break;
        case 95:
          this.goFrom = 'negotiate';
          break;
        case 96:
          this.goFrom = 'negotiate';
          break;
        case 97:
          this.goFrom = 'negotiate';
          break;
        case 98:
          this.goFrom = 'share';
          break;
        case 103:
          if(this.usType == '5'){
            this.goFrom = 'waitSign';
          } else if(this.usType == '3') {
            this.goFrom = 'receive'
          } else {
            this.goFrom = 'enterprise'
          }
          break;
        case 107:
          break;
        case 110:
          if(this.usType == '5'){
            this.goFrom = 'standardizedContractEmployee';
          } else {
            this.goFrom = 'standardizedContractSearch'
          }
          break;
        case 111:
          if(this.usType == '5'){
            this.goFrom = 'standardizedContractEmployee';
          } else {
            this.goFrom = 'standardizedContractSearch'
          }
          break;
        case 114:
          this.goFrom = 'viewDigital';
          break;
        case 115:
          this.goFrom = 'waitSignMoha';
          break;
        case 116:
          this.goFrom = 'waitSignDigital';
          break;
        case 117:
          this.goFrom = 'waitApproveDigital';
          break;
        case 118:
          this.goFrom = 'waitSignDigital';
          break;
        case 119:
          this.goFrom = 'waitApproveDigital';
          break;
        default:
          break;
      }
    } else {
      this.goFrom = '';
    }
    if (notify.notitficationType != EnumNotificationType.RESET_PASSWORD && notify.notitficationType != EnumNotificationType.CREATE_ACCOUNT
      && notify.notitficationType != EnumNotificationType.APPROVE_MULTI_SUCCESS && notify.notitficationType != EnumNotificationType.SIGN_MULTI_CANCEL
      && notify.notitficationType != EnumNotificationType.DECLINE_MULTI_SUCCESS && notify.notitficationType != EnumNotificationType.DECLINE_MULTI_CANCEL
      && notify.notitficationType != EnumNotificationType.SIGN_MULTI_SUCCESS && notify.notitficationType != EnumNotificationType.SIGN_MULTI_CANCEL
      && notify.notitficationType != EnumNotificationType.CANCEL_SIGN_FLOW && notify.notitficationType != EnumNotificationType.CREATE_CONTRACT_LOT
      && notify.notitficationType != EnumNotificationType.IMPORT_USER_FILE && notify.notitficationType != EnumNotificationType.IMPORT_CUSTOMER_FILE
      && notify.notitficationType != EnumNotificationType.CONTRACT_PERSONAL_CREATE && notify.notitficationType != EnumNotificationType.CONTRACT_ENTERPRISE_CREATE
      && notify.notitficationType != EnumNotificationType.CONTRACT_ENTERPRISE_RECEIVE && notify.notitficationType != EnumNotificationType.TOTAL_CONTRACT_REPORT
      && notify.notitficationType != EnumNotificationType.SMS_QUANTITY_REPORT && notify.notitficationType != EnumNotificationType.SMS_MONEY_REPORT
      && notify.notitficationType != EnumNotificationType.CONTRACT_PERSONAL_CREATE_ERROR && notify.notitficationType != EnumNotificationType.CONTRACT_ENTERPRISE_CREATE_ERROR
      && notify.notitficationType != EnumNotificationType.CONTRACT_ENTERPRISE_RECEIVE_ERROR && notify.notitficationType != EnumNotificationType.TOTAL_CONTRACT_REPORT_ERROR
      && notify.notitficationType != EnumNotificationType.SMS_QUANTITY_REPORT_ERROR && notify.notitficationType != EnumNotificationType.SMS_MONEY_REPORT_ERROR
      && notify.notitficationType != EnumNotificationType.SIGN_MULTI_FLOW_SUCCESS && notify.notitficationType != EnumNotificationType.SIGN_MULTI_FLOW_STOP
      && notify.notitficationType != EnumNotificationType.DELETE_MULTI_FLOW_SUCCESS && notify.notitficationType != EnumNotificationType.DELETE_MULTI_FLOW_STOP
      && notify.notitficationType != EnumNotificationType.CERTIFICATE_MONEY_SUCCESS && notify.notitficationType != EnumNotificationType.CERTIFICATE_MONEY_ERROR
      && notify.notitficationType != EnumNotificationType.TIMESTAMP_QUANTITY_SUCCESS && notify.notitficationType != EnumNotificationType.TIMESTAMP_QUANTITY_ERROR
      && notify.notitficationType != EnumNotificationType.EXPORT_CUSTOMER_SUCCESS && notify.notitficationType != EnumNotificationType.EXPORT_CUSTOMER_ERROR
      && notify.notitficationType != EnumNotificationType.DONE_INITIAL_WAIT_APPROVE && notify.notitficationType != EnumNotificationType.DONE_INITIAL_WAIT_APPROVE_CUSTOMER
      && notify.notitficationType != EnumNotificationType.NEED_APPROVE && notify.notitficationType != EnumNotificationType.DONE_SIGN_APPROVE
      && notify.notitficationType != EnumNotificationType.DONE_SIGN_APPROVE_CUSTOMER && notify.notitficationType != EnumNotificationType.CANCEL_SIGN_APPROVE_CUSTOMER
      && notify.notitficationType != EnumNotificationType.NOTIFICATION_TRANSFER_MONEY_STA_TO_SMS_SUCCESS && notify.notitficationType != EnumNotificationType.NOTIFICATION_TRANSFER_MONEY_SMS_TO_STA_SUCCESS
      && notify.notitficationType != EnumNotificationType.DIGITAL && notify.notitficationType != EnumNotificationType.SIGN_WAIT && notify.notitficationType !=EnumNotificationType.REPORT_USER_ERROR
      && notify.notitficationType !=EnumNotificationType.REPORT_USER_SUCCESS && notify.notitficationType !=EnumNotificationType.CONFIRM_FLOW_CANCEL && notify.notitficationType !=EnumNotificationType.CONFIRM_FLOW_SUCCESS
      && notify.notitficationType !=EnumNotificationType.CANCEL_FLOW_SUCCESS && notify.notitficationType !=EnumNotificationType.CANCEL_FLOW_CANCEL && notify.notitficationType !=EnumNotificationType.REPORT_PROCESSING_ERROR
      && notify.notitficationType !=EnumNotificationType.REPORT_PROCESSING_SUCCESS && notify.notitficationType !=EnumNotificationType.SIGN_MULTI_SUCCESS_DIGITAL  && notify.notitficationType !=EnumNotificationType.SIGN_MULTI_CANCEL_DIGITAL
      && notify.notitficationType !=EnumNotificationType.CREATE_CONTRACT_LOT_DIGITAL
      )
    {
      // this.router.navigate(['/home-enterprise/view-document/' + notify.contractId], {
      //   queryParams: {
      //     page: 0,
      //     pageSize: 10,
      //     goFrom: this.goFrom,
      //     routeLink: this.urlRouteLink,
      //   }
      // });

      this.router.navigate([this.getDocumentDetailRoute(notify)], {
        queryParams: {
          goFrom: this.getNotificationGoFrom(notify)
        }
      });

    }


    // Sign many documents -> redirect to search-document
    if (notify.notitficationType == EnumNotificationType.SIGN_WAIT) {
      localStorage.setItem("notifiData", JSON.stringify(notify))
      this.router.navigate(['/home-enterprise/digital-business/' + notify.contractId +'/view']);
    }
    if (notify.notitficationType == EnumNotificationType.DIGITAL) {
      localStorage.setItem("notifiData", JSON.stringify(notify))
      this.router.navigate(['/home-enterprise/digital-business/' + notify.contractId +'/view']);
    }
    if (notify.notitficationType == EnumNotificationType.APPROVE_MULTI_SUCCESS || notify.notitficationType == EnumNotificationType.APPROVE_MULTI_CANCEL) {
      localStorage.setItem("notifiData", JSON.stringify(notify))
      this.router.navigate(['/home-enterprise/approve-batch-result/']);
    }
    if (notify.notitficationType == EnumNotificationType.DECLINE_MULTI_SUCCESS || notify.notitficationType == EnumNotificationType.DECLINE_MULTI_CANCEL) {
      localStorage.setItem("notifiData", JSON.stringify(notify))
      this.router.navigate(['/home-enterprise/decline-approval-batch-result/']);
    }
    if (notify.notitficationType == EnumNotificationType.SIGN_MULTI_SUCCESS || notify.notitficationType == EnumNotificationType.SIGN_MULTI_CANCEL || notify.notitficationType == EnumNotificationType.SIGN_WAIT) {
      localStorage.setItem("notifiData", JSON.stringify(notify))
      localStorage.setItem("notitficationTypeSign",JSON.stringify(notify.notitficationType));
      this.router.navigate(['/home-enterprise/sign-batch-result/']);
    }
    if (notify.notitficationType == EnumNotificationType.CREATE_CONTRACT_LOT) {
      if(notify.contractLotType && notify.contractLotType === 'CONTRACT_MOHA' ){
        this.router.navigate(['/home-enterprise/contract-lot-moha/' + notify.contractLotId])
      } else if(notify.contractLotType && notify.contractLotType === 'CONTRACT_MOHA_STANDARDIZED' ){
        this.router.navigate(['/home-enterprise/contract-lot-standardized/' + notify.contractLotId])
      } else {
        this.router.navigate(['/home-enterprise/contract-lot/' + notify.contractLotId])
      }
    }

    if (notify.notitficationType == EnumNotificationType.CREATE_CONTRACT_LOT_DIGITAL) {
      this.router.navigateByUrl('/home-enterprise/contract-digital-add-lot/add-lot/' + notify.contractLotId);
    }
    
    if (notify.notitficationType == EnumNotificationType.IMPORT_USER_FILE) {
      this.router.navigate(['/home-enterprise/import-user/' + notify.objectId]);
    }
    if (notify.notitficationType == EnumNotificationType.IMPORT_CUSTOMER_FILE) {
      this.router.navigate(['/home-enterprise/import-customer/' + notify.objectId]);
    }
    if (notify.notitficationType == EnumNotificationType.CONTRACT_PERSONAL_CREATE || notify.notitficationType == EnumNotificationType.CONTRACT_PERSONAL_CREATE_ERROR) {
      this.router.navigate(['/home-enterprise/contract-personal-create/analysis-report/'])
    }
    if (notify.notitficationType == EnumNotificationType.REPORT_USER_SUCCESS || notify.notitficationType == EnumNotificationType.REPORT_USER_ERROR) {
      this.router.navigate(['/home-enterprise/contract-user-report/analysis-report/'])
    }
    if (notify.notitficationType == EnumNotificationType.CONTRACT_ENTERPRISE_CREATE || notify.notitficationType == EnumNotificationType.CONTRACT_ENTERPRISE_CREATE_ERROR) {
      this.router.navigate(['/home-enterprise/contract-enterprise-create/analysis-report/']);
    }
    if (notify.notitficationType == EnumNotificationType.CONTRACT_ENTERPRISE_RECEIVE || notify.notitficationType == EnumNotificationType.CONTRACT_ENTERPRISE_RECEIVE_ERROR) {
      this.router.navigate(['/home-enterprise/contract-enterprise-receive/analysis-report/']);
    }
    if (notify.notitficationType == EnumNotificationType.TOTAL_CONTRACT_REPORT || notify.notitficationType == EnumNotificationType.TOTAL_CONTRACT_REPORT_ERROR) {
      this.router.navigate(['/home-enterprise/total-contract-report/analysis-report/'])
    }
    if (notify.notitficationType == EnumNotificationType.SMS_QUANTITY_REPORT || notify.notitficationType == EnumNotificationType.SMS_QUANTITY_REPORT_ERROR) {
      this.router.navigate(['/home-enterprise/sms-quantity-report/analysis-report/']);
    }
    if (notify.notitficationType == EnumNotificationType.SMS_MONEY_REPORT || notify.notitficationType == EnumNotificationType.SMS_MONEY_REPORT_ERROR) {
      this.router.navigate(['/home-enterprise/sms-money-report/analysis-report/']);
    }
    if (notify.notitficationType == EnumNotificationType.SIGN_MULTI_FLOW_SUCCESS || notify.notitficationType == EnumNotificationType.SIGN_MULTI_FLOW_STOP
      || notify.notitficationType == EnumNotificationType.CONFIRM_FLOW_CANCEL || notify.notitficationType == EnumNotificationType.CONFIRM_FLOW_SUCCESS
      || notify.notitficationType == EnumNotificationType.CANCEL_FLOW_CANCEL || notify.notitficationType == EnumNotificationType.CANCEL_FLOW_SUCCESS
      || notify.notitficationType == EnumNotificationType.DELETE_MULTI_FLOW_SUCCESS || notify.notitficationType == EnumNotificationType.DELETE_MULTI_FLOW_STOP) {
      localStorage.setItem("notifiData", JSON.stringify(notify))
      localStorage.setItem("notitficationTypeSign",JSON.stringify(notify.notitficationType));
      this.router.navigate(['/home-enterprise/view-multiple-sign-flow/']);
    }
    if (notify.notitficationType == EnumNotificationType.CERTIFICATE_MONEY_SUCCESS || notify.notitficationType == EnumNotificationType.CERTIFICATE_MONEY_ERROR) {
      this.router.navigate(['/home-enterprise/certificate-money-report/analysis-report/'])
    }
    if (notify.notitficationType == EnumNotificationType.TIMESTAMP_QUANTITY_SUCCESS || notify.notitficationType == EnumNotificationType.TIMESTAMP_QUANTITY_ERROR) {
      this.router.navigate(['/home-enterprise/timestamp-quantity-report/analysis-report/']);
    }
    if (notify.notitficationType == EnumNotificationType.EXPORT_CUSTOMER_SUCCESS || notify.notitficationType == EnumNotificationType.EXPORT_CUSTOMER_ERROR) {
      this.router.navigate(['/home-enterprise/export-data-customer/']);
    }
    if (notify.notitficationType == EnumNotificationType.DONE_INITIAL_WAIT_APPROVE || notify.notitficationType == EnumNotificationType.DONE_INITIAL_WAIT_APPROVE_CUSTOMER ||
      notify.notitficationType == EnumNotificationType.DONE_SIGN_APPROVE || notify.notitficationType == EnumNotificationType.DONE_SIGN_APPROVE_CUSTOMER) {
      // 65, 66, 68, 69
      this.router.navigate([this.getDocumentDetailRoute(notify)], {
        queryParams: {
          goFrom: this.getNotificationGoFrom(notify)
        }
      });
    }
    if (notify.notitficationType == EnumNotificationType.NEED_APPROVE) {
      // 67
      this.router.navigate(['/home-enterprise/sign-confirm-document/' + notify.contractId], {
        queryParams: {
          goFrom: this.goFrom,
          needSign: true
        }
      });
    }
    if (notify.notitficationType == EnumNotificationType.RESULT_SYNC_CUSTOMER) {
      // 71
      this.router.navigate([`/home-enterprise/result-sync-customer/${notify.objectId}`], {
        queryParams: {
          goFrom: 'notification'
        }
      });
    }
    if (notify.notitficationType == EnumNotificationType.REPORT_PROCESSING_ERROR || notify.notitficationType == EnumNotificationType.REPORT_PROCESSING_SUCCESS) {
      this.router.navigate(['/home-enterprise/contract-processing/analysis-report/']);
    }
    if (notify.notitficationType == EnumNotificationType.SIGN_MULTI_SUCCESS_DIGITAL || notify.notitficationType == EnumNotificationType.SIGN_MULTI_CANCEL_DIGITAL) {
      localStorage.setItem("notifiData", JSON.stringify(notify))
      localStorage.setItem("notitficationTypeSign",JSON.stringify(notify.notitficationType));
      this.router.navigate(['/home-enterprise/sign-digital-batch-result/']);
    }

    notify.status = !notify.status;
  }

  private getDocumentDetailRoute(notify: Notify) {
    if (this.isDigitalEmploymentNotification(notify)) {
      if (this.goFrom === 'viewDigital') {
        return '/home-enterprise/contract-digitzation-moha/' + notify.contractId + '/view';
      }
      return '/home-enterprise/view-document-moha-digital/' + notify.contractId;
    }
    if (notify.isEmploymentContract) {
      return '/home-enterprise/view-document-moha/' + notify.contractId;
    }
    return '/home-enterprise/view-document/' + notify.contractId;
  }

  private getNotificationGoFrom(notify: Notify) {
    // if (notify.isDigitalEmploymentContract) {
    //   if (this.goFrom === 'waitSign') {
    //     return 'waitSignDigital';
    //   }
    //   if (this.goFrom === 'waitApprove') {
    //     return 'waitApproveDigital';
    //   }
    //   if (this.goFrom === 'mine') {
    //     return 'digitalMyEmployment';
    //   }
    // }

    return this.goFrom;
  }

  private isDigitalEmploymentNotification(notify: Notify) {
    return Boolean(notify.isDigitalEmploymentContract)
  }

  private isReciever(notify) {
    switch (notify.notitficationType) {
      case 2:
      case 4:
      case 9:
      case 10:
        return true;
      default:
        return false;
    }
    // return notify.notitficationType == 2 || notify.notitficationType == 4 || notify.notitficationType == 9 || notify.notitficationType == 10;
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.alive = false;
  }

  clearSelection() {
    clearSelectionJ();
  }
  parsedText(text) {
    const dom = new DOMParser().parseFromString(
      '<!doctype html><body>' + text,
      'text/html');
    const decodedString = dom.body.textContent;
    return decodedString;
  }

  StringFormat(str: string, ...args: string[]) {
    return str.replace(/{(\d+)}/g, (match, index) => args[index] || '')
  }

  getContent(notify) {
    // const data = JSON.parse(notify.content)
    return this.notifyService.getContent(notify);
    // if(notify.notitficationType !== 55 && notify.notitficationType !== 56){
    //   return this.notifyService.getContent(notify);
    // }
    // if (notify.notitficationType === 55) {
    //   const data = JSON.parse(notify.content)
    //   return this.translate.instant('notifi-25-0') + ' ' + data.startHour + ' '
    //     + this.translate.instant('notifi-25-1') + ' ' + data.startDate + ' '
    //     + this.translate.instant('notifi-25-2-0')+'. <br>'
    //     + this.translate.instant('notifi-25-8');
    // } else if (notify.notitficationType === 56) {
    //   const data = JSON.parse(notify.content)
    //   return this.translate.instant('notifi-25-0') + ' ' + data.startHour + ' '
    //   + this.translate.instant('notifi-25-1') + ' ' + data.startDate + ' '
    //   + this.translate.instant('notifi-25-2-1')+'. <br>'
    //   + this.translate.instant('notifi-25-8');
    // }

  }
}

